export const utf8ToBase64 = str => {
    const uint8Array = new TextEncoder().encode(str);
    const binaryString = Array.from(uint8Array)
        .map(byte => String.fromCharCode(byte))
        .join('');
    const res = btoa(binaryString);
    return res;
};

export const base64ToUtf8 = base64 => {
    const binaryString = atob(base64);
    const uint8Array = new Uint8Array(binaryString.split('').map(char => char.charCodeAt(0)));
    return new TextDecoder().decode(uint8Array);
};

export const isBase64 = str => {
    // Check if the string is empty or null
    if (!str || typeof str !== 'string') {
        return false;
    }

    // Base64 regex pattern
    const base64Regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;

    // Check if the length is a multiple of 4 and matches the regex
    return str.length % 4 === 0 && base64Regex.test(str);
};
